import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Table, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { adminAPI } from '../../services/api';
import { FaUsers, FaBox, FaShoppingCart, FaDollarSign } from 'react-icons/fa';
import AdminLayout from '../../components/AdminLayout';

const Dashboard = () => {
  const [analytics, setAnalytics] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchAnalytics();
  }, []);

  const fetchAnalytics = async () => {
    try {
      const response = await adminAPI.getAnalytics();
      setAnalytics(response.data);
    } catch (error) {
      console.error('Failed to fetch analytics');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <Container className="my-5 text-center">
        <Spinner animation="border" variant="primary" />
      </Container>
    );
  }

  return (
    <AdminLayout>
    <Container fluid className="my-4">
      <h1 className="mb-4">Admin Dashboard</h1>

      {/* Overview Cards */}
      <Row className="mb-4">
        <Col md={3}>
          <Card className="text-center">
            <Card.Body>
              <FaUsers size={40} className="text-primary mb-2" />
              <h3>{analytics?.overview?.totalUsers || 0}</h3>
              <p className="text-muted">Total Users</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="text-center">
            <Card.Body>
              <FaBox size={40} className="text-success mb-2" />
              <h3>{analytics?.overview?.totalProducts || 0}</h3>
              <p className="text-muted">Total Products</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="text-center">
            <Card.Body>
              <FaShoppingCart size={40} className="text-info mb-2" />
              <h3>{analytics?.overview?.totalOrders || 0}</h3>
              <p className="text-muted">Total Orders</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="text-center">
            <Card.Body>
              <FaDollarSign size={40} className="text-warning mb-2" />
              <h3>₹{analytics?.overview?.totalRevenue || 0}</h3>
              <p className="text-muted">Total Revenue</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col md={6}>
          <Card>
            <Card.Header>
              <h5>Top Selling Products</h5>
            </Card.Header>
            <Card.Body>
              <Table striped hover>
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Sold</th>
                    <th>Revenue</th>
                  </tr>
                </thead>
                <tbody>
                  {analytics?.topProducts?.map((item, index) => (
                    <tr key={index}>
                      <td>{item.product?.name}</td>
                      <td>{item.totalSold}</td>
                      <td>₹{item.totalRevenue}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6}>
          <Card>
            <Card.Header>
              <h5>License Keys Stats</h5>
            </Card.Header>
            <Card.Body>
              <Table striped>
                <tbody>
                  <tr>
                    <td><strong>Total Keys:</strong></td>
                    <td>{analytics?.licenseKeyStats?.total || 0}</td>
                  </tr>
                  <tr>
                    <td><strong>Available:</strong></td>
                    <td className="text-success">{analytics?.licenseKeyStats?.available || 0}</td>
                  </tr>
                  <tr>
                    <td><strong>Used:</strong></td>
                    <td className="text-danger">{analytics?.licenseKeyStats?.used || 0}</td>
                  </tr>
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card>
            <Card.Header>
              <h5>Recent Orders</h5>
            </Card.Header>
            <Card.Body>
              <Table responsive hover>
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>Customer</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {analytics?.recentOrders?.map((order) => (
                    <tr key={order._id}>
                      <td><small>{order._id.slice(-8)}</small></td>
                      <td>{order.userId?.name}</td>
                      <td>₹{order.totalAmount}</td>
                      <td>
                        <span className={`order-status ${order.paymentStatus}`}>
                          {order.paymentStatus}
                        </span>
                      </td>
                      <td>{new Date(order.createdAt).toLocaleDateString()}</td>
                      <td>
                        <Link to={`/admin/orders`}>View</Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
    </AdminLayout>
  );
};

export default Dashboard;
